/* OTUNBA Header — dynamic announcement height + scroll-state toggle */
(function () {
  function setup() {
    if (!document.body.classList.contains("template-index")) return;
    var ann = document.querySelector(".utility-bar");
    function syncHeights() {
      if (ann) {
        var h = ann.offsetHeight;
        document.documentElement.style.setProperty("--otunba-announce-h", h + "px");
      }
    }
    function onScroll() {
      var threshold = ann ? Math.max(20, ann.offsetHeight - 4) : 30;
      if (window.scrollY > threshold) document.body.classList.add("otunba-scrolled");
      else document.body.classList.remove("otunba-scrolled");
    }
    syncHeights();
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", function () { syncHeights(); onScroll(); }, { passive: true });
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setup);
  } else {
    setup();
  }
})();
